import { render, staticRenderFns } from "./allOrders.vue?vue&type=template&id=a5c453b0&scoped=true&"
import script from "./allOrders.vue?vue&type=script&lang=js&"
export * from "./allOrders.vue?vue&type=script&lang=js&"
import style0 from "./allOrders.vue?vue&type=style&index=0&id=a5c453b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c453b0",
  null
  
)

export default component.exports